import { observer } from "mobx-react-lite";
import useLoginRequired from "../../common/hooks/useLoginRequired";
import NotLoggedIn from "../../components/NotLoggedIn";
import PowerBIReport from "../../components/PowerBIReport";
import authStore from "../../stores/auth/authStore";

/**
 * Page for showing the "Årets Matglede" campaign report.
 */
const JoyOfFoodCampaignPage = () => {
   useLoginRequired("SEGMENTED_CONTENT");

   if (!authStore.isLoggedIn()) {
      return <NotLoggedIn />;
   }

   const reportName = authStore.getCurrentCompany()?.customerGroup.startsWith("010|")
      ? "aretsmatglede_dagligvare"
      : "aretsmatglede";

   return (
      <PowerBIReport
         reportName={reportName}
         title={`Utvikling for ${authStore.getCurrentCompany()?.name}`}
         mobileHeightRatio={4}
      />
   );
};

export default observer(JoyOfFoodCampaignPage);
